import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ArrayMinSize,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour ajouter des membres à un groupe (bulk)
 */
export class AddGroupMembersDto {
  @ApiProperty({
    description: 'IDs des utilisateurs étudiants à ajouter au groupe',
    type: [String],
    example: ['user-1', 'user-2', 'user-3'],
  })
  @IsArray()
  @ArrayMinSize(1, { message: 'Au moins un étudiant doit être spécifié' })
  @IsString({ each: true })
  studentUserIds!: string[]

  @ApiPropertyOptional({
    type: 'string',
    description: "Date d'adhésion (par défaut: maintenant)",
    example: '2024-01-15T08:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  joinedAt?: string
}

/**
 * DTO pour retirer un membre d'un groupe
 */
export class RemoveGroupMemberDto {
  @ApiProperty({
    type: 'string',
    description: "ID de l'utilisateur étudiant à retirer",
    example: 'user-123',
  })
  @IsNotEmpty()
  @IsString()
  studentUserId!: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Date de départ (par défaut: maintenant)',
    example: '2024-06-30T17:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  leftAt?: string
}

/**
 * DTO pour modifier le statut d'un membre
 */
export class UpdateGroupMemberStatusDto {
  @ApiPropertyOptional({
    type: 'string',
    description: 'Date de départ du groupe',
    example: '2024-06-30T17:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  leftAt?: string

  @ApiPropertyOptional({
    type: Boolean,
    description: 'Statut actif du membre',
    example: true,
  })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean
}
